import "./RoboticsCourseHP1.module.css";
import Header from "@/reusable_sections/Header";
import CourseDetailHP1 from "./sections/CourseDetailHP1";
import Footer from "@/reusable_sections/Footer";
export default function RoboticsCourseHP1Page() {
  return <div>
      <Header />
      <CourseDetailHP1 />
      <Footer />
    </div>;
}